import { QuestionOutlined } from "@ant-design/icons"
import { Value } from "sass"
import { ICustomerTypes } from "../api/selectOption/selectOptionsApi"


export const optionsZNSType = [
  { label: "ZNS OTP", value: "ZNS OTP" },
  { label: "ZNS đánh giá dịch vụ", value: "ZNS đánh giá dịch vụ" },
  { label: "ZNS thông báo giao dịch", value: "ZNS thông báo giao dịch" },
  { label: "ZNS nhắc lịch hẹn", value: "ZNS nhắc lịch hẹn" },
  { label: "ZNS Voucher", value: "ZNS Voucher" },
];

export const dataGender = [
  {
    value: 0,
    title: "Nam",
    label: 'Nam'
  },
  {
    value: 1,
    title: "Nữ",
    label: 'Nữ'
  },
  {
    value: 2,
    title: "Không xác định",
    label: 'Không xác định'
  }
]

export const dataStatusMarital = [
  {
    value: 0,
    title: "Độc thân"
  },
  {
    value: 1,
    title: "Đã kết hôn"
  },
  {
    value: 2,
    title: "Không xác định"
  }

]

export const dataSoft = [
  { value: 1, label: 'Từ A-Z' },
  { value: 0, label: 'Từ Z-A' },
]

export const dataTypeGroup = [
  { value: 2, label: 'Tất cả' },
  { value: 0, label: 'Nhóm riêng tư' },
  { value: 1, label: 'Nhóm có thể chia sẻ' },
]
export const statusVoucher = [
  {
    label: 'Đang hoạt động',
    Value: 1,
  },
  {
    label: 'Đã kết thúc',
    Value: 0,
  },
  {
    label: 'Sắp diễn ra',
    Value: 2,
  },
]

export const typeReduced = [
  {
    label: 'Số tiền',
    Value: 0,
  },
  {
    label: 'Phần trăm',
    Value: 1,
  },

]


export enum ConditionUsed {
  PRODUCT = 0,
  PART = 1,
  SERVICE = 2,
}

export const ConditionOptions = [
  {
    label: 'Sản phẩm',
    value: 0,
  },
  {
    label: 'Phụ tùng',
    value: 1,
  },
  {
    label: 'Dịch vụ',
    value: 2,
  },
]



export const DataSendingForm = [
  { value: 0, label: 'Ưu tiên gửi theo kênh' },
  { value: 1, label: 'Đồng thời gửi nhiều kênh' },
]

export const DataChannel = [
  { value: 1, label: 'SMS' },
  { value: 2, label: 'ZNS' },
  { value: 3, label: 'Email' },
]

export const StatusSendCampaign = [
  { value: 0, label: 'Chờ gửi' },
  { value: 1, label: 'Đang gửi' },
  { value: 2, label: 'Hoàn thành' },
  { value: 3, label: 'Tạm dừng' },
]

export const DataStatusButton = [
  { value: 0, label: 'Chưa kích hoạt' },
  { value: 1, label: 'Đang sử dụng' },
]

export const DataAuthType = [
  {
    value: 1,
    title: "Tên đăng nhập"
  },
  {
    value: 2,
    title: "Chứng chỉ SSL"
  },
  {
    value: 3,
    title: "Gmail OAuth Authentication"
  }
]
export const DataEncryptionType = [
  {
    value: 1,
    title: "Không"
  },
  {
    value: 2,
    title: "TLS"
  },
  {
    value: 3,
    title: "SSL/TLS"
  }
]
export const dataOption = [
  { value: 0, label: 'Khóa' },
  { value: 1, label: 'Khởi tạo' },
  { value: 2, label: 'Gửi duyệt' },
  { value: 3, label: 'Đã duyệt' },
  { value: 4, label: 'Từ chối' },
]
export const dataOptionStatus = [
  { value: 1, title: 'Khuyến mãi' },
  { value: 2, title: 'Thông báo' },
  { value: 3, title: 'Tiếp thị' },
  { value: 4, title: 'CSKH' }
]
export enum CHANNELTYPE {
  SMS = 1,
  ZNS = 2,
  EMAIL = 3
}
export const paginationDF = { current: 1, pageSize: 10, total: 0 }
export const dataType = [
  { value: 0, label: 'Showroom' },
  { value: 1, label: 'Xưởng' },
]

export enum CustomerType {
  Individual = 0,   // Cá nhân
  Organization = 1, // Đơn vị, tổ chức
}
export const dataTypeCustomer = [
  { value: CustomerType.Individual, label: 'Cá nhân' },
  { value: CustomerType.Organization, label: 'Đơn vị, tổ chức' },
]
export const dataTypeCustomer2 = [
  { value: 0, label: 'KH bên ngoài (CEB)' },
  { value: 1, label: 'KH nội bộ (CI0)' },
  { value: 2, label: 'Không xác định' },
]
export const dataTypeDocument = [
  { value: 0, label: 'CCCD/CMND' },
  { value: 1, label: 'Hộ chiếu' },
]

export enum CustomerTabType {
  CareFeedback = 1,          // Tất cả
  Sales = 2,          // Bán hàng
  Service = 3,          //dịch vụ
  SupportComplaint = 4,      // Hỗ trợ/Khiếu nại
  Survey = 5,                // Khảo sát
  InUse = 6,                 // Xe sử dụng
  Owned = 7,                 // Xe sở hữu
  Interested = 8,            // Xe quan tâm
  Invoice = 9                // Danh sách hóa đơn
}


export const genders = [
  { value: 0, label: 'Nam', icon: <svg width="1.143em" height="1.143em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14.4643 1H9.96429C9.90536 1 9.85714 1.04821 9.85714 1.10714V2.10714C9.85714 2.16607 9.90536 2.21429 9.96429 2.21429H12.8286L9.26964 5.77321C8.37679 5.08571 7.2875 4.71429 6.14286 4.71429C4.76964 4.71429 3.47679 5.25 2.50714 6.22143C1.5375 7.19286 1 8.48393 1 9.85714C1 11.2304 1.53571 12.5232 2.50714 13.4929C3.47679 14.4643 4.76964 15 6.14286 15C7.51607 15 8.80893 14.4643 9.77857 13.4929C10.75 12.5232 11.2857 11.2304 11.2857 9.85714C11.2857 8.7125 10.9143 7.62679 10.2286 6.73393L13.7857 3.17679V6.03572C13.7857 6.09464 13.8339 6.14286 13.8929 6.14286H14.8929C14.9518 6.14286 15 6.09464 15 6.03572V1.53571C15 1.24107 14.7589 1 14.4643 1ZM6.14286 13.6429C4.05536 13.6429 2.35714 11.9446 2.35714 9.85714C2.35714 7.76964 4.05536 6.07143 6.14286 6.07143C8.23036 6.07143 9.92857 7.76964 9.92857 9.85714C9.92857 11.9446 8.23036 13.6429 6.14286 13.6429Z" fill="#1890FF" /> </svg> },
  { value: 1, label: 'Nữ', icon: <svg width="1.143em" height="1.143em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clipPath="url(#clip0_15451_51524)"> <path d="M11.5859 8.65714C12.543 7.7 13.0716 6.425 13.0716 5.07143C13.0716 3.71607 12.5448 2.44286 11.5859 1.48571C10.6287 0.528571 9.35371 0 8.00014 0C6.64657 0 5.37157 0.526786 4.41443 1.48571C3.45728 2.44464 2.92871 3.71607 2.92871 5.07143C2.92871 6.21071 3.30193 7.29286 3.98943 8.17679C4.11978 8.34464 4.26085 8.50357 4.41264 8.65714C4.56443 8.80893 4.72514 8.95 4.89121 9.08036C5.59835 9.63036 6.43228 9.98036 7.32157 10.0982V12H5.28585C5.20728 12 5.143 12.0643 5.143 12.1429V13.2143C5.143 13.2929 5.20728 13.3571 5.28585 13.3571H7.32157V15.8571C7.32157 15.9357 7.38585 16 7.46443 16H8.53585C8.61443 16 8.67871 15.9357 8.67871 15.8571V13.3571H10.7144C10.793 13.3571 10.8573 13.2929 10.8573 13.2143V12.1429C10.8573 12.0643 10.793 12 10.7144 12H8.67871V10.0982C9.77693 9.95179 10.7894 9.45357 11.5859 8.65714ZM8.00014 8.78572C7.00728 8.78572 6.07693 8.4 5.37335 7.69821C4.67157 6.99643 4.28585 6.06429 4.28585 5.07143C4.28585 4.07857 4.67157 3.14821 5.37335 2.44464C6.07514 1.74107 7.00728 1.35714 8.00014 1.35714C8.993 1.35714 9.92335 1.74286 10.6269 2.44464C11.3287 3.14643 11.7144 4.07857 11.7144 5.07143C11.7144 6.06429 11.3287 6.99464 10.6269 7.69821C9.92335 8.4 8.993 8.78572 8.00014 8.78572Z" fill="#8C62FF" /> </g> <defs> <clipPath id="clip0_15451_51524"> <rect width="16" height="16" fill="white" /> </clipPath> </defs> </svg> },
  {
    value: 2, label: "Khác", icon: <svg width="1.143em" height="1.143em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.6 4C1.6 2.675 2.675 1.6 4 1.6C5.325 1.6 6.4 2.675 6.4 4C6.4 5.0675 5.7025 5.9725 4.7375 6.285C4.0275 6.515 3.2 7.1675 3.2 8.2V8.8C3.2 9.2425 3.5575 9.6 4 9.6C4.4425 9.6 4.8 9.2425 4.8 8.8V8.2C4.8 8.1575 4.815 8.0975 4.8875 8.0175C4.9625 7.935 5.085 7.855 5.23 7.8075C6.8375 7.29 8 5.7825 8 4C8 1.79 6.21 0 4 0C1.79 0 0 1.79 0 4C0 4.4425 0.3575 4.8 0.8 4.8C1.2425 4.8 1.6 4.4425 1.6 4ZM4 12.8C4.5525 12.8 5 12.3525 5 11.8C5 11.2475 4.5525 10.8 4 10.8C3.4475 10.8 3 11.2475 3 11.8C3 12.3525 3.4475 12.8 4 12.8Z" fill="#667085" /><defs> <clipPath id="clip0_15451_51524"> <rect width="16" height="16" fill="white" /> </clipPath> </defs>
    </svg>

  }
]

export const dataTypeAddress = [
  { value: 0, label: 'Phụ' },
  { value: 1, label: 'Chính' },
]

export const dataCarCustomerTypes: ICustomerTypes[] = [
  {
    id: 1,
    title: 'DL',
    color: 'F5222D',
    backgroundColor: 'FFF1F0',
    code: 'DL(Du lịch)'
  },
  {
    id: 2,
    title: 'TM',
    color: '1890FF',
    backgroundColor: 'E6F7FF',
    code: '(TM)Tải bus'
  }
];


export const dataTimeLogOut = [
  {
    value: 5,
    title: "5",
  },
  {
    value: 10,
    title: "10",
  },
  {
    value: 15,
    title: "15",
  },
  {
    value: 30,
    title: "30",
  },
  {
    value: 60,
    title: "60",
  }
]

export enum CARTYPE {
  CAR_BUS = 2,
  CAR = 1,
}

export enum FIELDTYPE {
  CUSTOMER = 1,

  OWNED_VEHICLE = 2,
  USING_VEHICLE = 3,
  INTERESTED_VEHICLE = 4,

  // Car
  invoices = 5,                 // Hợp đồng bán xe
  insurance = 6,                // Bảo hiểm xe
  maintenanceHistory = 7,       // Dịch vụ sửa chữa
  maintenanceHistoryForUsed = 14,       // Dịch vụ sửa chữa
  infoCar = 8,                  // ⚠️ Không thấy trong ảnh, giữ nguyên
  contactHistoryByOwnedCar = 9, // Lịch sử tiếp xúc KH xe sở hữu
  contactHistoryByInterestedCar = 15, // ❗ sửa từ 9 → 15

  // Vehicle Invoice
  VehicleInvoice = 10,          // Hóa đơn bán xe
  VehicleInvoiceDetail = 16,    // ❗ sửa từ 11 → 16

  // Service & Maintenance
  ServiceMaintenanceInvoice = 11,        // ❗ sửa từ 12 → 11
  ServiceMaintenanceInvoiceDetail = 17,  // ❗ sửa từ 13 → 17

  // Sales & Service Care
  SalesAndService = 12,         // ❗ sửa từ 14 → 12
  SalesAndServiceDetail = 19,   // ❗ sửa từ 15 → 19

  // Support / Complaint
  SupportHistory = 13,          // ❗ sửa từ 16 → 13
  SupportHistoryDetail = 20,    // ❗ sửa từ 17 → 20

  // Survey
  SurveyInformation = 21,       // ❗ sửa từ 18 → 21
  SurveyInformationDetail = 22, // đúng



  //voucher là recordId 23 chiến dịch 24
  Voucher = 23,

  MarketingCampaign = 24,


  // danh sách customer trong nhóm

  CustomerInGroup = 28,

  VoucherCodeDetail = 30,
  CardIssuanceDetail = 31,
  ContactPerson = 32,
}


export const NO_DATA = "Không xác định"
export const NO_VIEW = "******"

export enum TypeExportCustomer {
  CUSTOMER = 0,
  VEHICLE = 1

}

export enum LogHistoryType {
  CUSTOMER = 1,           // Khách hàng
  CUSTOMER_GROUP = 2,     // Nhóm khách hàng
  LOGIN = 3,              // Đăng nhập
  EMPLOYEE = 4,           // Nhân viên
  UNIT = 5,               // Đơn vị
  ROLE_GROUP = 6,         // Nhóm quyền
  EMPLOYEE_PERMISSION = 7 // Phân quyền nhân viên
}



//#region  lịch sử hỗ trợ kiếu nại
export const dataInteractionType = [
  { value: "F3", label: "Khiếu nại" },
  { value: "F2", label: "Phàn nàn" },
  { value: "Khác", label: "Khác" },
]

export const dataInteractionCategory = [
  { value: "KH liên hệ", label: "KH liên hệ" },
  { value: "THACO liên hệ", label: "THACO liên hệ" }
]

export const dataInteractionCategory_V2 = [
  { value: "QA", label: "Chăm sóc bán hàng, dịch vụ" },
  { value: "S1", label: "Đặt lịch hẹn sửa chữa" }
]

export const datachanelFbName = [
  { value: "Hotline CSKH-VPDH", label: "Hotline CSKH-VPDH" },
  { value: "Fanpage Thương hiệu", label: "Fanpage Thương hiệu" },
  { value: "Khảo sát sự hài lòng KH-VPDH", label: "Khảo sát sự hài lòng KH-VPDH" },
  { value: "Đại lý", label: "Đại lý" },
  { value: "Hộp mail CSKH-VPDH", label: "Hộp mail CSKH-VPDH" },
  { value: "Khác", label: "Khác" },
];

export const datachanelFbNameIPCC = [
  { value: "1900545591 (IPCC)", label: "1900545591 (IPCC)" },
  { value: "Email CSKH (IPCC)", label: "Email CSKH (IPCC)" },
  { value: "Facebook (IPCC)", label: "Facebook (IPCC)" },
  { value: "Khảo sát DCSI (IPCC)", label: "Khảo sát DCSI (IPCC)" },
  { value: "Khảo sát VOC (IPCC)", label: "Khảo sát VOC (IPCC)" },
  { value: "Website (IPCC)", label: "Website (IPCC)" }
];

export const dataDocStatusEndName = [
  { value: "Đã đóng", label: "Đã đóng" },
  { value: "Đang xử lý", label: "Đang xử lý" },
  { value: "Tiếp nhận & phân loại", label: "Tiếp nhận & phân loại" }
];

export const dataDocResultName = [
  { value: "Hài lòng", label: "Hài lòng" },
  { value: "Không hài lòng", label: "Không hài lòng" }
];


export const dataComplainNameTreeDDMS = [
  {
    title: "Bàn giao xe",
    value: "Bàn giao xe",
    children: [
      {
        title: "Quy trình bàn giao xe",
        value: "Bàn giao xe/Quy trình bàn giao xe",
      },
      {
        title: "Thời gian bàn giao xe",
        value: "Bàn giao xe/Thời gian bàn giao xe",
      },
    ],
  },
  {
    title: "Chi phí",
    value: "Chi phí",
  },
  {
    title: "Chính sách bán hàng",
    value: "Chính sách bán hàng",
  },
  {
    title: "Cơ sở vật chất /tiện nghi",
    value: "Cơ sở vật chất /tiện nghi",
  },
  {
    title: "KD DVHT",
    value: "KD DVHT",
  },
  {
    title: "Năng lực nhân sự bán hàng",
    value: "Năng lực nhân sự bán hàng",
  },
  {
    title: "Quy trình bán hàng",
    value: "Quy trình bán hàng",
    children: [
      {
        title: "Quy trình ký hợp đồng",
        value: "Quy trình bán hàng/Quy trình ký hợp đồng",
      },
      {
        title: "Quy trình tư vấn",
        value: "Quy trình bán hàng/Quy trình tư vấn",
      },
      {
        title: "Quy trình lái thử xe",
        value: "Quy trình bán hàng/Quy trình lái thử xe",
      },
      {
        title: "Quy trình thanh toán",
        value: "Quy trình bán hàng/Quy trình thanh toán",
      },
      {
        title: "Quy trình tiếp đón",
        value: "Quy trình bán hàng/Quy trình tiếp đón",
      },
    ],
  },
  {
    title: "Sản phẩm/ Phụ kiện",
    value: "Sản phẩm/ Phụ kiện",
  },
  {
    title: "Thái độ nhân viên",
    value: "Thái độ nhân viên",
  },
  {
    title: "Khác",
    value: "Khác",
  },
];


export const dataComplainNameTreeIPCC = [
  {
    title: "Kinh doanh",
    value: "Kinh doanh",
    children: [
      {
        title: "Khiếu nại",
        value: "Kinh doanh/Khiếu nại",
        children: [
          {
            title: "Bàn giao xe",
            value: "Kinh doanh/Khiếu nại/Bàn giao xe",
          },
          {
            title: "Chất lượng sửa chữa",
            value: "Kinh doanh/Khiếu nại/Chất lượng sửa chữa",
            children: [
              {
                title: "Sửa chữa chung",
                value: "Kinh doanh/Khiếu nại/Chất lượng sửa chữa/Sửa chữa chung",
              },
              {
                title: "Đồng sơn",
                value: "Kinh doanh/Khiếu nại/Chất lượng sửa chữa/Đồng sơn",
              },
            ],
          },
          {
            title: "Chi phí sửa chữa",
            value: "Kinh doanh/Khiếu nại/Chi phí sửa chữa",
          },
          {
            title: "Cơ sở vật chất",
            value: "Kinh doanh/Khiếu nại/Cơ sở vật chất",
          },
          {
            title: "Năng lực TDV",
            value: "Kinh doanh/Khiếu nại/Năng lực TDV",
          },
          {
            title: "Quy trình bán hàng",
            value: "Kinh doanh/Khiếu nại/Quy trình bán hàng",
            children: [
              {
                title: "Quy trình thanh toán",
                value: "Kinh doanh/Khiếu nại/Quy trình bán hàng/Quy trình thanh toán",
              },
              {
                title: "Quy trình lái thử xe",
                value: "Kinh doanh/Khiếu nại/Quy trình bán hàng/Quy trình lái thử xe",
              },
            ],
          },
          {
            title: "Thái độ nhân viên",
            value: "Kinh doanh/Khiếu nại/Thái độ nhân viên",
          },
          {
            title: "Thời gian chờ phụ tùng",
            value: "Kinh doanh/Khiếu nại/Thời gian chờ phụ tùng",
            children: [
              {
                title: "Không chủ động thông báo thời gian",
                value: "Kinh doanh/Khiếu nại/Thời gian chờ phụ tùng/Không chủ động thông báo thời gian",
              },
              {
                title: "Thời gian chờ lâu",
                value: "Kinh doanh/Khiếu nại/Thời gian chờ phụ tùng/Thời gian chờ lâu",
              },
            ],
          },
          {
            title: "Thời gian sửa chữa",
            value: "Kinh doanh/Khiếu nại/Thời gian sửa chữa",
            children: [
              {
                title: "Thời gian chờ lâu",
                value: "Kinh doanh/Khiếu nại/Thời gian sửa chữa/Thời gian chờ lâu",
              },
            ],
          },
          {
            title: "Vệ sinh khi bàn giao xe",
            value: "Kinh doanh/Khiếu nại/Vệ sinh khi bàn giao xe",
          },
          {
            title: "Hỗ trợ khách hàng",
            value: "Kinh doanh/Khiếu nại/Hỗ trợ khách hàng",
            children: [
              {
                title: "Chính sách bán hàng",
                value: "Kinh doanh/Khiếu nại/Hỗ trợ khách hàng/Chính sách bán hàng",
              },
              {
                title: "Khác",
                value: "Kinh doanh/Khiếu nại/Hỗ trợ khách hàng/Khác",
              },
            ],
          },
        ],
      },
      {
        title: "Phụ tùng/ phụ kiện",
        value: "Kinh doanh/Phụ tùng/ phụ kiện",
        children: [
          {
            title: "Khiếu nại",
            value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại",
            children: [
              {
                title: "Bàn giao xe",
                value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Bàn giao xe",
              },
              {
                title: "Chất lượng sửa chữa",
                value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Chất lượng sửa chữa",
                children: [
                  {
                    title: "Sửa chữa chung",
                    value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Chất lượng sửa chữa/Sửa chữa chung",
                  },
                  {
                    title: "Đồng sơn",
                    value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Chất lượng sửa chữa/Đồng sơn",
                  },
                ],
              },
              {
                title: "Chi phí sửa chữa",
                value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Chi phí sửa chữa",
              },
              {
                title: "Cơ sở vật chất",
                value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Cơ sở vật chất",
              },
              {
                title: "Năng lực TDV",
                value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Năng lực TDV",
              },
              {
                title: "Quy trình bán hàng",
                value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Quy trình bán hàng",
                children: [
                  {
                    title: "Quy trình thanh toán",
                    value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Quy trình bán hàng/Quy trình thanh toán",
                  },
                  {
                    title: "Quy trình lái thử xe",
                    value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Quy trình bán hàng/Quy trình lái thử xe",
                  },
                ],
              },
              {
                title: "Thái độ nhân viên",
                value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Thái độ nhân viên",
              },
              {
                title: "Thời gian chờ phụ tùng",
                value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Thời gian chờ phụ tùng",
                children: [
                  {
                    title: "Không chủ động thông báo thời gian",
                    value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Thời gian chờ phụ tùng/Không chủ động thông báo thời gian",
                  },
                ],
              },
              {
                title: "Thời gian sửa chữa",
                value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Thời gian sửa chữa",
                children: [
                  {
                    title: "Thời gian chờ lâu",
                    value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Thời gian sửa chữa/Thời gian chờ lâu",
                  },
                ],
              },
              {
                title: "Vệ sinh khi bàn giao xe",
                value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Vệ sinh khi bàn giao xe",
              },
              {
                title: "Hỗ trợ khách hàng",
                value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Hỗ trợ khách hàng",
                children: [
                  {
                    title: "Chính sách bán hàng",
                    value: "Kinh doanh/Phụ tùng/ phụ kiện/Khiếu nại/Hỗ trợ khách hàng/Chính sách bán hàng",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        title: "Dịch vụ",
        value: "Kinh doanh/Dịch vụ",
        children: [
          {
            title: "Khiếu nại",
            value: "Kinh doanh/Dịch vụ/Khiếu nại",
            children: [
              {
                title: "Bàn giao xe",
                value: "Kinh doanh/Dịch vụ/Khiếu nại/Bàn giao xe",
              },
              {
                title: "Chất lượng sửa chữa",
                value: "Kinh doanh/Dịch vụ/Khiếu nại/Chất lượng sửa chữa",
                children: [
                  {
                    title: "Sửa chữa chung",
                    value: "Kinh doanh/Dịch vụ/Khiếu nại/Chất lượng sửa chữa/Sửa chữa chung",
                  },
                  {
                    title: "Đồng sơn",
                    value: "Kinh doanh/Dịch vụ/Khiếu nại/Chất lượng sửa chữa/Đồng sơn",
                  },
                ],
              },
              {
                title: "Chi phí sửa chữa",
                value: "Kinh doanh/Dịch vụ/Khiếu nại/Chi phí sửa chữa",
              },
              {
                title: "Cơ sở vật chất",
                value: "Kinh doanh/Dịch vụ/Khiếu nại/Cơ sở vật chất",
              },
              {
                title: "Năng lực TDV",
                value: "Kinh doanh/Dịch vụ/Khiếu nại/Năng lực TDV",
              },
              {
                title: "Quy trình bán hàng",
                value: "Kinh doanh/Dịch vụ/Khiếu nại/Quy trình bán hàng",
                children: [
                  {
                    title: "Quy trình thanh toán",
                    value: "Kinh doanh/Dịch vụ/Khiếu nại/Quy trình bán hàng/Quy trình thanh toán",
                  },
                  {
                    title: "Quy trình lái thử xe",
                    value: "Kinh doanh/Dịch vụ/Khiếu nại/Quy trình bán hàng/Quy trình lái thử xe",
                  },
                ],
              },
              {
                title: "Thái độ nhân viên",
                value: "Kinh doanh/Dịch vụ/Khiếu nại/Thái độ nhân viên",
              },
              {
                title: "Thời gian chờ phụ tùng",
                value: "Kinh doanh/Dịch vụ/Khiếu nại/Thời gian chờ phụ tùng",
                children: [
                  {
                    title: "Không chủ động thông báo thời gian",
                    value: "Kinh doanh/Dịch vụ/Khiếu nại/Thời gian chờ phụ tùng/Không chủ động thông báo thời gian",
                  },
                ],
              },
              {
                title: "Thời gian sửa chữa",
                value: "Kinh doanh/Dịch vụ/Khiếu nại/Thời gian sửa chữa",
                children: [
                  {
                    title: "Thời gian chờ lâu",
                    value: "Kinh doanh/Dịch vụ/Khiếu nại/Thời gian sửa chữa/Thời gian chờ lâu",
                  },
                ],
              },
              {
                title: "Vệ sinh khi bàn giao xe",
                value: "Kinh doanh/Dịch vụ/Khiếu nại/Vệ sinh khi bàn giao xe",
              },
              {
                title: "Hỗ trợ khách hàng",
                value: "Kinh doanh/Dịch vụ/Khiếu nại/Hỗ trợ khách hàng",
                children: [
                  {
                    title: "Chính sách bán hàng",
                    value: "Kinh doanh/Dịch vụ/Khiếu nại/Hỗ trợ khách hàng/Chính sách bán hàng",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

// export const dataComplainNameTree = [
//   {
//     title: "KIA",
//     value: "KIA",
//     children: [
//       {
//         title: "Kinh doanh",
//         value: "KIA/Kinh doanh",
//         children: [
//           {
//             title: "Khiếu nại",
//             value: "KIA/Kinh doanh/Khiếu nại",
//             children: [
//               {
//                 title: "Bàn giao xe",
//                 value: "KIA/Kinh doanh/Khiếu nại/Bàn giao xe"
//               },
//               {
//                 title: "Chất lượng sửa chữa",
//                 value: "KIA/Kinh doanh/Khiếu nại/Chất lượng sửa chữa",
//                 children: [
//                   {
//                     title: "Sửa chữa chung",
//                     value:
//                       "KIA/Kinh doanh/Khiếu nại/Chất lượng sửa chữa/Sửa chữa chung"
//                   },
//                   {
//                     title: "Đồng sơn",
//                     value:
//                       "KIA/Kinh doanh/Khiếu nại/Chất lượng sửa chữa/Đồng sơn"
//                   }
//                 ]
//               },
//               {
//                 title: "Chi phí sửa chữa",
//                 value: "KIA/Kinh doanh/Khiếu nại/Chi phí sửa chữa"
//               },
//               {
//                 title: "Cơ sở vật chất",
//                 value: "KIA/Kinh doanh/Khiếu nại/Cơ sở vật chất"
//               },
//               {
//                 title: "Năng lực TVDV",
//                 value: "KIA/Kinh doanh/Khiếu nại/Năng lực TVDV"
//               },
//               {
//                 title: "Quy trình bán hàng",
//                 value: "KIA/Kinh doanh/Khiếu nại/Quy trình bán hàng",
//                 children: [
//                   {
//                     title: "Quy trình thanh toán",
//                     value:
//                       "KIA/Kinh doanh/Khiếu nại/Quy trình bán hàng/Quy trình thanh toán"
//                   },
//                   {
//                     title: "Quy trình lái thử xe",
//                     value:
//                       "KIA/Kinh doanh/Khiếu nại/Quy trình bán hàng/Quy trình lái thử xe"
//                   }
//                 ]
//               },
//               {
//                 title: "Thái độ nhân viên",
//                 value: "KIA/Kinh doanh/Khiếu nại/Thái độ nhân viên"
//               },
//               {
//                 title: "Thời gian chờ phụ tùng",
//                 value: "KIA/Kinh doanh/Khiếu nại/Thời gian chờ phụ tùng",
//                 children: [
//                   {
//                     title: "Không chủ động thông báo thời gian",
//                     value:
//                       "KIA/Kinh doanh/Khiếu nại/Thời gian chờ phụ tùng/Không chủ động thông báo thời gian"
//                   },
//                   {
//                     title: "Thời gian chờ lâu",
//                     value:
//                       "KIA/Kinh doanh/Khiếu nại/Thời gian chờ phụ tùng/Thời gian chờ lâu"
//                   }
//                 ]
//               },
//               {
//                 title: "Thời gian sửa chữa",
//                 value: "KIA/Kinh doanh/Khiếu nại/Thời gian sửa chữa",
//                 children: [
//                   {
//                     title: "Thời gian chờ lâu",
//                     value:
//                       "KIA/Kinh doanh/Khiếu nại/Thời gian sửa chữa/Thời gian chờ lâu"
//                   }
//                 ]
//               },
//               {
//                 title: "Vệ sinh khi bàn giao xe",
//                 value: "KIA/Kinh doanh/Khiếu nại/Vệ sinh khi bàn giao xe"
//               },
//               {
//                 title: "Hỗ trợ khách hàng",
//                 value: "KIA/Kinh doanh/Khiếu nại/Hỗ trợ khách hàng",
//                 children: [
//                   {
//                     title: "Chính sách bán hàng",
//                     value:
//                       "KIA/Kinh doanh/Khiếu nại/Hỗ trợ khách hàng/Chính sách bán hàng"
//                   },
//                   {
//                     title: "Khác",
//                     value:
//                       "KIA/Kinh doanh/Khiếu nại/Hỗ trợ khách hàng/Khác"
//                   }
//                 ]
//               }
//             ]
//           }
//         ]
//       },

//       {
//         title: "Phụ tùng/phụ kiện",
//         value: "KIA/Phụ tùng/phụ kiện",
//         children: [
//           {
//             title: "Khiếu nại",
//             value: "KIA/Phụ tùng/phụ kiện/Khiếu nại",
//             children: [
//               {
//                 title: "Bàn giao xe",
//                 value:
//                   "KIA/Phụ tùng/phụ kiện/Khiếu nại/Bàn giao xe"
//               },
//               {
//                 title: "Chất lượng sửa chữa",
//                 value:
//                   "KIA/Phụ tùng/phụ kiện/Khiếu nại/Chất lượng sửa chữa"
//               },
//               {
//                 title: "Chi phí sửa chữa",
//                 value:
//                   "KIA/Phụ tùng/phụ kiện/Khiếu nại/Chi phí sửa chữa"
//               },
//               {
//                 title: "Cơ sở vật chất",
//                 value:
//                   "KIA/Phụ tùng/phụ kiện/Khiếu nại/Cơ sở vật chất"
//               },
//               {
//                 title: "Năng lực TVDV",
//                 value:
//                   "KIA/Phụ tùng/phụ kiện/Khiếu nại/Năng lực TVDV"
//               },
//               {
//                 title: "Quy trình bán hàng",
//                 value:
//                   "KIA/Phụ tùng/phụ kiện/Khiếu nại/Quy trình bán hàng"
//               },
//               {
//                 title: "Thái độ nhân viên",
//                 value:
//                   "KIA/Phụ tùng/phụ kiện/Khiếu nại/Thái độ nhân viên"
//               },
//               {
//                 title: "Thời gian chờ phụ tùng",
//                 value:
//                   "KIA/Phụ tùng/phụ kiện/Khiếu nại/Thời gian chờ phụ tùng"
//               },
//               {
//                 title: "Thời gian sửa chữa",
//                 value:
//                   "KIA/Phụ tùng/phụ kiện/Khiếu nại/Thời gian sửa chữa"
//               },
//               {
//                 title: "Vệ sinh khi bàn giao xe",
//                 value:
//                   "KIA/Phụ tùng/phụ kiện/Khiếu nại/Vệ sinh khi bàn giao xe"
//               }
//             ]
//           }
//         ]
//       },

//       {
//         title: "Dịch vụ",
//         value: "KIA/Dịch vụ",
//         children: [
//           {
//             title: "Khiếu nại",
//             value: "KIA/Dịch vụ/Khiếu nại",
//             children: [
//               {
//                 title: "Bàn giao xe",
//                 value: "KIA/Dịch vụ/Khiếu nại/Bàn giao xe"
//               },
//               {
//                 title: "Chất lượng sửa chữa",
//                 value:
//                   "KIA/Dịch vụ/Khiếu nại/Chất lượng sửa chữa"
//               },
//               {
//                 title: "Chi phí sửa chữa",
//                 value:
//                   "KIA/Dịch vụ/Khiếu nại/Chi phí sửa chữa"
//               },
//               {
//                 title: "Cơ sở vật chất",
//                 value:
//                   "KIA/Dịch vụ/Khiếu nại/Cơ sở vật chất"
//               },
//               {
//                 title: "Năng lực TVDV",
//                 value:
//                   "KIA/Dịch vụ/Khiếu nại/Năng lực TVDV"
//               },
//               {
//                 title: "Quy trình bán hàng",
//                 value:
//                   "KIA/Dịch vụ/Khiếu nại/Quy trình bán hàng"
//               },
//               {
//                 title: "Thái độ nhân viên",
//                 value:
//                   "KIA/Dịch vụ/Khiếu nại/Thái độ nhân viên"
//               },
//               {
//                 title: "Thời gian chờ phụ tùng",
//                 value:
//                   "KIA/Dịch vụ/Khiếu nại/Thời gian chờ phụ tùng"
//               },
//               {
//                 title: "Thời gian sửa chữa",
//                 value:
//                   "KIA/Dịch vụ/Khiếu nại/Thời gian sửa chữa"
//               },
//               {
//                 title: "Vệ sinh khi bàn giao xe",
//                 value:
//                   "KIA/Dịch vụ/Khiếu nại/Vệ sinh khi bàn giao xe"
//               },
//               {
//                 title: "Hỗ trợ khách hàng",
//                 value:
//                   "KIA/Dịch vụ/Khiếu nại/Hỗ trợ khách hàng"
//               },
//               {
//                 title: "Khác",
//                 value: "KIA/Dịch vụ/Khiếu nại/Khác"
//               }
//             ]
//           }
//         ]
//       }
//     ]
//   },
//   {
//     title: "MAZDA",
//     value: "MAZDA",
//     children: [
//       {
//         title: "Kinh doanh",
//         value: "MAZDA/Kinh doanh",
//         children: [
//           {
//             title: "Khiếu nại",
//             value: "MAZDA/Kinh doanh/Khiếu nại",
//             children: [
//               {
//                 title: "Bàn giao xe",
//                 value: "MAZDA/Kinh doanh/Khiếu nại/Bàn giao xe"
//               },
//               {
//                 title: "Chất lượng sửa chữa",
//                 value: "MAZDA/Kinh doanh/Khiếu nại/Chất lượng sửa chữa",
//                 children: [
//                   {
//                     title: "Sửa chữa chung",
//                     value:
//                       "MAZDA/Kinh doanh/Khiếu nại/Chất lượng sửa chữa/Sửa chữa chung"
//                   },
//                   {
//                     title: "Đồng sơn",
//                     value:
//                       "MAZDA/Kinh doanh/Khiếu nại/Chất lượng sửa chữa/Đồng sơn"
//                   }
//                 ]
//               },
//               {
//                 title: "Chi phí sửa chữa",
//                 value: "MAZDA/Kinh doanh/Khiếu nại/Chi phí sửa chữa"
//               },
//               {
//                 title: "Cơ sở vật chất",
//                 value: "MAZDA/Kinh doanh/Khiếu nại/Cơ sở vật chất"
//               },
//               {
//                 title: "Năng lực TVDV",
//                 value: "MAZDA/Kinh doanh/Khiếu nại/Năng lực TVDV"
//               },
//               {
//                 title: "Quy trình bán hàng",
//                 value: "MAZDA/Kinh doanh/Khiếu nại/Quy trình bán hàng",
//                 children: [
//                   {
//                     title: "Quy trình thanh toán",
//                     value:
//                       "MAZDA/Kinh doanh/Khiếu nại/Quy trình bán hàng/Quy trình thanh toán"
//                   },
//                   {
//                     title: "Quy trình lái thử xe",
//                     value:
//                       "MAZDA/Kinh doanh/Khiếu nại/Quy trình bán hàng/Quy trình lái thử xe"
//                   }
//                 ]
//               },
//               {
//                 title: "Thái độ nhân viên",
//                 value: "MAZDA/Kinh doanh/Khiếu nại/Thái độ nhân viên"
//               },
//               {
//                 title: "Thời gian chờ phụ tùng",
//                 value: "MAZDA/Kinh doanh/Khiếu nại/Thời gian chờ phụ tùng",
//                 children: [
//                   {
//                     title: "Không chủ động thông báo thời gian",
//                     value:
//                       "MAZDA/Kinh doanh/Khiếu nại/Thời gian chờ phụ tùng/Không chủ động thông báo thời gian"
//                   },
//                   {
//                     title: "Thời gian chờ lâu",
//                     value:
//                       "MAZDA/Kinh doanh/Khiếu nại/Thời gian chờ phụ tùng/Thời gian chờ lâu"
//                   }
//                 ]
//               },
//               {
//                 title: "Thời gian sửa chữa",
//                 value: "MAZDA/Kinh doanh/Khiếu nại/Thời gian sửa chữa",
//                 children: [
//                   {
//                     title: "Thời gian chờ lâu",
//                     value:
//                       "MAZDA/Kinh doanh/Khiếu nại/Thời gian sửa chữa/Thời gian chờ lâu"
//                   }
//                 ]
//               },
//               {
//                 title: "Vệ sinh khi bàn giao xe",
//                 value: "MAZDA/Kinh doanh/Khiếu nại/Vệ sinh khi bàn giao xe"
//               },
//               {
//                 title: "Hỗ trợ khách hàng",
//                 value: "MAZDA/Kinh doanh/Khiếu nại/Hỗ trợ khách hàng",
//                 children: [
//                   {
//                     title: "Chính sách bán hàng",
//                     value:
//                       "MAZDA/Kinh doanh/Khiếu nại/Hỗ trợ khách hàng/Chính sách bán hàng"
//                   },
//                   {
//                     title: "Khác",
//                     value:
//                       "MAZDA/Kinh doanh/Khiếu nại/Hỗ trợ khách hàng/Khác"
//                   }
//                 ]
//               }
//             ]
//           }
//         ]
//       },

//       {
//         title: "Phụ tùng/phụ kiện",
//         value: "MAZDA/Phụ tùng/phụ kiện",
//         children: [
//           {
//             title: "Khiếu nại",
//             value: "MAZDA/Phụ tùng/phụ kiện/Khiếu nại",
//             children: [
//               {
//                 title: "Bàn giao xe",
//                 value:
//                   "MAZDA/Phụ tùng/phụ kiện/Khiếu nại/Bàn giao xe"
//               },
//               {
//                 title: "Chất lượng sửa chữa",
//                 value:
//                   "MAZDA/Phụ tùng/phụ kiện/Khiếu nại/Chất lượng sửa chữa"
//               },
//               {
//                 title: "Chi phí sửa chữa",
//                 value:
//                   "MAZDA/Phụ tùng/phụ kiện/Khiếu nại/Chi phí sửa chữa"
//               },
//               {
//                 title: "Cơ sở vật chất",
//                 value:
//                   "MAZDA/Phụ tùng/phụ kiện/Khiếu nại/Cơ sở vật chất"
//               },
//               {
//                 title: "Năng lực TVDV",
//                 value:
//                   "MAZDA/Phụ tùng/phụ kiện/Khiếu nại/Năng lực TVDV"
//               },
//               {
//                 title: "Quy trình bán hàng",
//                 value:
//                   "MAZDA/Phụ tùng/phụ kiện/Khiếu nại/Quy trình bán hàng"
//               },
//               {
//                 title: "Thái độ nhân viên",
//                 value:
//                   "MAZDA/Phụ tùng/phụ kiện/Khiếu nại/Thái độ nhân viên"
//               },
//               {
//                 title: "Thời gian chờ phụ tùng",
//                 value:
//                   "MAZDA/Phụ tùng/phụ kiện/Khiếu nại/Thời gian chờ phụ tùng"
//               },
//               {
//                 title: "Thời gian sửa chữa",
//                 value:
//                   "MAZDA/Phụ tùng/phụ kiện/Khiếu nại/Thời gian sửa chữa"
//               },
//               {
//                 title: "Vệ sinh khi bàn giao xe",
//                 value:
//                   "MAZDA/Phụ tùng/phụ kiện/Khiếu nại/Vệ sinh khi bàn giao xe"
//               }
//             ]
//           }
//         ]
//       },

//       {
//         title: "Dịch vụ",
//         value: "MAZDA/Dịch vụ",
//         children: [
//           {
//             title: "Khiếu nại",
//             value: "MAZDA/Dịch vụ/Khiếu nại",
//             children: [
//               {
//                 title: "Bàn giao xe",
//                 value: "MAZDA/Dịch vụ/Khiếu nại/Bàn giao xe"
//               },
//               {
//                 title: "Chất lượng sửa chữa",
//                 value:
//                   "MAZDA/Dịch vụ/Khiếu nại/Chất lượng sửa chữa"
//               },
//               {
//                 title: "Chi phí sửa chữa",
//                 value:
//                   "MAZDA/Dịch vụ/Khiếu nại/Chi phí sửa chữa"
//               },
//               {
//                 title: "Cơ sở vật chất",
//                 value:
//                   "MAZDA/Dịch vụ/Khiếu nại/Cơ sở vật chất"
//               },
//               {
//                 title: "Năng lực TVDV",
//                 value:
//                   "MAZDA/Dịch vụ/Khiếu nại/Năng lực TVDV"
//               },
//               {
//                 title: "Quy trình bán hàng",
//                 value:
//                   "MAZDA/Dịch vụ/Khiếu nại/Quy trình bán hàng"
//               },
//               {
//                 title: "Thái độ nhân viên",
//                 value:
//                   "MAZDA/Dịch vụ/Khiếu nại/Thái độ nhân viên"
//               },
//               {
//                 title: "Thời gian chờ phụ tùng",
//                 value:
//                   "MAZDA/Dịch vụ/Khiếu nại/Thời gian chờ phụ tùng"
//               },
//               {
//                 title: "Thời gian sửa chữa",
//                 value:
//                   "MAZDA/Dịch vụ/Khiếu nại/Thời gian sửa chữa"
//               },
//               {
//                 title: "Vệ sinh khi bàn giao xe",
//                 value:
//                   "MAZDA/Dịch vụ/Khiếu nại/Vệ sinh khi bàn giao xe"
//               },
//               {
//                 title: "Hỗ trợ khách hàng",
//                 value:
//                   "MAZDA/Dịch vụ/Khiếu nại/Hỗ trợ khách hàng"
//               },
//               {
//                 title: "Khác",
//                 value: "MAZDA/Dịch vụ/Khiếu nại/Khác"
//               }
//             ]
//           }
//         ]
//       }
//     ]
//   }
// ];



export const dataProcessLevel = [
  { value: "Đại lý", label: "Đại lý" },
];


//#endregion




//#region  Chăm sóc bán hàng dịch vụ
// 0 Lịch hẹn sữa chữa, 1 Bán hàng dịch vụ
export enum SERVICETYPE {
  SCHEDULEAREPAIR = 0,
  SALEANDSERVICE = 1,
}

//#endregion


//#region  thông tin khảo sát

export enum SURVEYTYPE {
  SERVICESURVEY = "Khảo sát dịch vụ",
  BUSINESSSURVEY = "Khảo sát kinh doanh"
}

export const dataSurveyInformationInteractionType = [
  { value: "Khảo sát dịch vụ", label: "Khảo sát dịch vụ" },
  { value: "Khảo sát kinh doanh", label: "Khảo sát kinh doanh" }
]

//#endregion

export enum VehicleStatusEnum {
  SOLD = 0,
  IN_USE = 1,
}

export const dataVehicleStatus = [
  { value: VehicleStatusEnum.SOLD, label: 'Đã bán' },
  { value: VehicleStatusEnum.IN_USE, label: 'Đang dùng' },
]



//#region  thông tin Cấu hình hệ thống
// SMS


//#endregion



//#region voucher
export const typeVoucher = [
  {
    label: 'Công khai',
    Value: 0,
  },
  {
    label: 'Cho nhóm',
    Value: 1,
  },
  {
    label: 'Cá nhân',
    Value: 2,
  },
]
export enum VoucherTypeTable {
  UN_USE = 0,              // chưa đổi
  USED = 1,  // Đã đổi
  ALL = 2,//
}

export enum VoucherAction {
  SAVE = 0,
  SAVEANDSEND = 1,
  SUBMIT = 2,   // Gửi duyệt Chỉ áp dụng cho voucher ở trạng thái Nháp (0)
  APPROVE = 3,  // Phê duyệt Chỉ áp dụng cho voucher ở trạng thái Chờ duyệt (1)
  PAUSE = 4,    // Tạm dừng Chỉ áp dụng cho voucher ở trạng thái Đang hoạt động (3)
  REJECT = 5,   // Từ chối Chỉ áp dụng cho voucher ở trạng thái Chờ duyệt (1)
  RESUME = 6,   // Đang hoạt động lại Chỉ áp dụng cho voucher ở trạng thái Tạm dừng (4)
}

export enum VoucherDetailStatusEnum {
  DRAFT = 0,              // Nháp
  AWAITING_APPROVAL = 1,  // Chờ duyệt
  AWAITING_ACTIVATION = 2,// Chờ kích hoạt
  ACTIVE = 3,             // Đang hoạt động
  PAUSED = 4,             // Tạm dừng
  REJECTED = 5,           // Từ chối
  ENDED = 6,              // Đã kết thúc
}

export const statusVoucherDetail = [
  {
    value: VoucherDetailStatusEnum.DRAFT,
    title: "Nháp",
  },
  {
    value: VoucherDetailStatusEnum.AWAITING_APPROVAL,
    title: "Chờ duyệt",
  },
  {
    value: VoucherDetailStatusEnum.AWAITING_ACTIVATION,
    title: "Chờ kích hoạt",
  },
  {
    value: VoucherDetailStatusEnum.ACTIVE,
    title: "Đang hoạt động",
  },
  {
    value: VoucherDetailStatusEnum.PAUSED,
    title: "Tạm dừng",
  },
  {
    value: VoucherDetailStatusEnum.REJECTED,
    title: "Từ chối",
  },
  {
    value: VoucherDetailStatusEnum.ENDED,
    title: "Đã kết thúc",
  },
];
//#endregion


export const dataSendEvent = [
  { value: 0, label: 'Ngày sinh' },
  { value: 1, label: 'Nhắc bảo dưỡng' },
]




// quản trị hệ thống

// Log
export enum ModuleTypeLog {
  Customer = 1,                 // khách hàng
  CustomerGroup = 2,            // nhóm khách hàng
  Login = 3,                    // đăng nhập
  Employee = 4,                 // nhân viên
  Unit = 5,                     // đơn vị
  PermissionGroup = 6,          // nhóm quyền
  EmployeePermission = 7,       // phân quyền nhân viên
  Car = 8,                      // xe
  NationalUnit = 9,             // đơn vị toàn quốc
  RegionalUnit = 10,            // đơn vị vùng miền
  Showroom = 11,                // showroom
  Department = 12,              // phòng ban
  Vehicle = 13,                 // vehicle
  CustomerVehicle = 14,         // customer-vehicle
  VehiclePlateNumber = 15,      // vehicle-plate-number
  VehicleBooking = 16,          // vehicle_booking
  VehicleInsurance = 17,        // vehicle_insurance
  CustomerInteractions = 18,    // customer_interactions
  InvoiceSale = 19,             // invoice_sale
  CustomerOwnedVehicle = 20,    // xe sở hữu khách hàng
}
